import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActionCardConfigInterface, BrightsideUiModule } from '@brightside/brightside-ui';
import { Router } from '@angular/router';

@Component({
    selector: 'brightside-web-spending-initial-card',
    templateUrl: './spending-initial-card.component.html',
    styleUrls: ['./spending-initial-card.component.scss'],
    imports: [BrightsideUiModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpendingInitialCardComponent {
  private _router: Router = inject(Router);

  spendingInitialCard: ActionCardConfigInterface = {
    label: 'FINANCIAL_TOOL_SPENDING_LABEL',
    title: 'FINANCIAL_TOOL_SPENDING_TITLE',
    image: '/assets/spending-card-wings.png',
    cardStyle: 'small',
    shadow: true,
    backgroundSize: 'cover',
    removeMaxWidth: true
  }

  routeToSpending() {
    this._router.navigate(['accounts', 'spending', 'dashboard']);
  }
}
